export default "__VITE_ASSET__Drc27IIJ__"